/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

/**
 *
 * @export
 * @interface GuidedSailCreateInstanceResult
 */
export interface GuidedSailCreateInstanceResultOptional {
  /**
   * Created instance ID if successful
   * @type {number}
   * @memberof GuidedSailCreateInstanceResult
   */
  instanceId?: number;
  /**
   * Current number of signups if successful
   * @type {number}
   * @memberof GuidedSailCreateInstanceResult
   */
  currentSignups?: number;
  /**
   * Error message if failed
   * @type {string}
   * @memberof GuidedSailCreateInstanceResult
   */
  error?: string;
}

export interface GuidedSailCreateInstanceResult extends GuidedSailCreateInstanceResultOptional {
  /**
   * Created instance ID if successful
   * @type {number}
   * @memberof GuidedSailCreateInstanceResult
   */
  instanceId?: number;
  /**
   * Current number of signups if successful
   * @type {number}
   * @memberof GuidedSailCreateInstanceResult
   */
  currentSignups?: number;
  /**
   * Error message if failed
   * @type {string}
   * @memberof GuidedSailCreateInstanceResult
   */
  error?: string;
}

export interface GuidedSailCreateInstanceResultTrackedI {
  /**
   * Created instance ID if successful
   * @type {number}
   * @memberof GuidedSailCreateInstanceResult
   */
  instanceId?: number;
  instanceIdIsSet: boolean;
  /**
   * Current number of signups if successful
   * @type {number}
   * @memberof GuidedSailCreateInstanceResult
   */
  currentSignups?: number;
  currentSignupsIsSet: boolean;
  /**
   * Error message if failed
   * @type {string}
   * @memberof GuidedSailCreateInstanceResult
   */
  error?: string;
  errorIsSet: boolean;
}

transformDatesMap.set(
  "GuidedSailCreateInstanceResult",
  function (model: GuidedSailCreateInstanceResult) {},
);

export type GuidedSailCreateInstanceResultMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  instanceId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  currentSignups: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  error: PropertyMeta<MetaTypeBase<string>>;
}>;

export var GuidedSailCreateInstanceResultMeta: GuidedSailCreateInstanceResultMetaI =
  {} as GuidedSailCreateInstanceResultMetaI;
GuidedSailCreateInstanceResultMeta = typeMeta(
  "GuidedSailCreateInstanceResult",
  {
    instanceId: propertyMeta(
      "instanceId",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    currentSignups: propertyMeta(
      "currentSignups",
      false,
      false,
      false,
      MetaTypesBase.number,
    ),
    error: propertyMeta("error", false, false, false, MetaTypesBase.string),
  },
);

const metaI = GuidedSailCreateInstanceResultMeta;

registerMeta(() => {});

export class GuidedSailCreateInstanceResultTracked implements GuidedSailCreateInstanceResultTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  instanceId__I?: number = undefined;
  instanceIdIsSet: boolean = false;
  set instanceId(v: undefined | number) {
    if (v !== undefined) {
      this.instanceId__I = v;
      this.instanceIdIsSet = true;
    } else {
      this.instanceId__I = v || undefined;
      this.instanceIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceId() {
    return this.instanceId__I;
  }
  currentSignups__I?: number = undefined;
  currentSignupsIsSet: boolean = false;
  set currentSignups(v: undefined | number) {
    if (v !== undefined) {
      this.currentSignups__I = v;
      this.currentSignupsIsSet = true;
    } else {
      this.currentSignups__I = v || undefined;
      this.currentSignupsIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentSignups() {
    return this.currentSignups__I;
  }
  error__I?: string = undefined;
  errorIsSet: boolean = false;
  set error(v: undefined | string) {
    if (v !== undefined) {
      this.error__I = v;
      this.errorIsSet = true;
    } else {
      this.error__I = v || undefined;
      this.errorIsSet = false;
    }
    this.changeTracker = true;
  }
  get error() {
    return this.error__I;
  }
  constructor(
    config?: GuidedSailCreateInstanceResultOptional,
    options?: AssignOptions,
  ) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: GuidedSailCreateInstanceResultOptional,
    options?: AssignOptions,
  ): GuidedSailCreateInstanceResultTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.instanceId &&
      this.instanceIdApplyFilter(optionsRequired.filter)
    ) {
      this.instanceId = config.instanceId;
      if (optionsRequired.unassign) this.instanceIdIsSet = false;
      else this.instanceIdIsSet = true;
    }
    if (
      config.currentSignups &&
      this.currentSignupsApplyFilter(optionsRequired.filter)
    ) {
      this.currentSignups = config.currentSignups;
      if (optionsRequired.unassign) this.currentSignupsIsSet = false;
      else this.currentSignupsIsSet = true;
    }
    if (config.error && this.errorApplyFilter(optionsRequired.filter)) {
      this.error = config.error;
      if (optionsRequired.unassign) this.errorIsSet = false;
      else this.errorIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): GuidedSailCreateInstanceResultTrackedI {
    const cloned = {} as GuidedSailCreateInstanceResultTrackedI;
    if (
      this.instanceIdIsSetDeep() &&
      this.instanceIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceIdIsSet = true;
      cloned.instanceId = this.instanceId;
    } else {
      //cloned.instanceIdIsSet = false
    }
    if (
      this.currentSignupsIsSetDeep() &&
      this.currentSignupsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentSignupsIsSet = true;
      cloned.currentSignups = this.currentSignups;
    } else {
      //cloned.currentSignupsIsSet = false
    }
    if (
      this.errorIsSetDeep() &&
      this.errorApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.errorIsSet = true;
      cloned.error = this.error;
    } else {
      //cloned.errorIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): GuidedSailCreateInstanceResultTrackedI {
    if (!this.instanceIdApplyFilter(filter)) this.instanceIdIsSet = false;

    if (!this.currentSignupsApplyFilter(filter))
      this.currentSignupsIsSet = false;

    if (!this.errorApplyFilter(filter)) this.errorIsSet = false;

    return this;
  }
  instanceIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuidedSailCreateInstanceResultMeta.instanceId,
      GuidedSailCreateInstanceResultMeta,
      this.instanceId,
      this,
    );
  }
  instanceIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.instanceIdIsSet && this.instanceIdApplyFilter(filter)) return true;

    return false;
  }
  currentSignupsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuidedSailCreateInstanceResultMeta.currentSignups,
      GuidedSailCreateInstanceResultMeta,
      this.currentSignups,
      this,
    );
  }
  currentSignupsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.currentSignupsIsSet && this.currentSignupsApplyFilter(filter))
      return true;

    return false;
  }
  errorApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      GuidedSailCreateInstanceResultMeta.error,
      GuidedSailCreateInstanceResultMeta,
      this.error,
      this,
    );
  }
  errorIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.errorIsSet && this.errorApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.instanceIdIsSetDeep(filter)) return true;
    if (this.currentSignupsIsSetDeep(filter)) return true;
    if (this.errorIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
